module.exports = __webpack_public_path__ + "static/media/Nutshell.147661a2.webp";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/v2/about/Nutshell.webp
// module id = 594
// module chunks = 8